import { featureFlagsConstants } from '../constants/featureFlags.constants'
import { getFeatureFlags } from '../services/admin.service'

export const featureFlagsActions = {
    get
}

function get() {
    return dispatch => {
        dispatch(request())
        getFeatureFlags().then(
            response => {
                dispatch(success(response))
            },
            error => {
                dispatch(failure(error))
            }
        )
    }

    function request() {
        return { type: featureFlagsConstants.GET_REQUEST }
    }
    function success(response) {
        return { type: featureFlagsConstants.GET_SUCCESS, response }
    }
    function failure(error) {
        return { type: featureFlagsConstants.GET_FAILURE, error }
    }
}
